import React, { useEffect } from "react";
import { userService } from "../../_services";

function PassRedirect() {
    useEffect(() => {
        try {
            const queryParams = new URLSearchParams(window.location.search);
            const value = queryParams.get('shortCode');
            activateUserAccount(value, window.location.href);
        } catch (err) {}
    }, []);

    function activateUserAccount(code, url) {
        userService.passredirect(code, url)
            .then(apidata => {
                try {
                    if (apidata.length > 0) {
                        window.location.href = apidata[0].code;
                    } else {
                        window.location.href = window.location.origin + "/page-not-found";
                    }
                } catch (error) {
                    window.location.href = window.location.origin + "/page-not-found";
                }
            });
    }

    return <div />;
}

export default PassRedirect;
